import { InternalizationService } from './i18n.service';

export function bootstrapInternalizationModule(i18nService: InternalizationService) {
  return () => i18nService.init();
}



// WEBPACK FOOTER //
// ./src/config/i18n/i18n.bootstrap.ts